<template>
  <div class="">
    <div class="col-12 mb-primary">
      <div class="card border-0 h-100">
        <div class="card-header p-primary bg-transparent">
          <h5 class="card-title d-inline-block mb-0">{{ $t("site") }}</h5>
        </div>
        <!-- <app-overlay-loader v-if="preloader" /> -->
        <div class="card-body">
          <form
            class="mb-0"
            ref="form"
            :data-url="selectedUrl ? `crud/${inputs.id}` : `crud`"
          >
            <div class="form-group row align-items-center">
              <label for="inputs_name" class="col-sm-3 mb-0">
                {{ $t("title") }}
              </label>
              <app-input
                id="inputs_name"
                class="col-sm-9"
                type="text"
                v-model="site.title"
                :required="true"
              />
            </div>
            <div class="form-group row align-items-center">
              <label for="inputs_email" class="col-sm-3 mb-0">
                {{ $t("description") }}
              </label>
              <app-input
                id="inputs_email"
                class="col-sm-9"
                type="textarea"
                v-model="site.description"
                :required="true"
              />
            </div>
            <div class="form-group row align-items-center">
              <label for="inputs_email" class="col-sm-3 mb-0">
                {{ $t("start_time") }}
              </label>
              <app-input
                id="inputs_email"
                class="col-sm-3"
                type="time"
                v-model="site.start_time"
                :required="true"
              />
              <label for="inputs_email" class="col-sm-3 mb-0">
                {{ $t("end_time") }}
              </label>
              <app-input
                id="inputs_email"
                class="col-sm-3"
                type="time"
                v-model="site.end_time"
                :required="true"
              />
            </div>

            <div class="mt-5 action-buttons" style="text-align: end">
              <app-load-more
                :preloader="preloader"
                :label="$t('submit')"
                type="submit"
                class-name="btn btn-primary mr-2 text-center"
                @submit="updateSite"
              />
              <!-- <button
                type="submit"
                class="btn btn-primary mr-2"
                @click.prevent="updateSite"
              >
                {{ $t("submit") }}
              </button> -->
              <button
                type="submit"
                class="btn btn-secondary"
                @click.prevent="clear"
              >
                {{ $t("clear") }}
              </button>
            </div>
          </form>
        </div>

        <div class="card-body">
          <form
            ref="form"
            data-url="/crud"
            class="mb-0"
            :class="{ 'loading-opacity': preloader }"
          >
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <label>{{ $t("site_list") }}</label>
                <table class="table">
                  <tr>
                    <th>S.No</th>
                    <th>Title</th>
                    <th>Action</th>
                  </tr>
                  <tr v-for="(task, index) in tasks" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ task.title }}</td>
                    <td>
                      <a
                        href="#"
                        v-on:click="setSite(task.id)"
                        class="btn btn-primary btn-sm"
                        >view</a
                      >
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <company-upload
      v-if="isAddEditModalActive"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
    />
  </div>
</template>

<script>
import { interactionSettingsStore } from "@fullcalendar/common";
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
import {
  COMPANY_JOB_SITE_SHOW,
  COMPANY_JOB_SITE_UPDATE,
  COMPANY_JOB_UPDATE,
} from "../../../../../Config/ApiUrl.js";
import { axiosGet, axiosPost } from "../../../../../Helpers/AxiosHelper.js";

export default {
  name: "FormGrid",
  mixins: [FormMixin],
  data() {
    return {
      isAddEditModalActive: false,
      preloader: false,
      site: {},
      tasks: {},
    };
  },
  props: ["id"],
  methods: {
    setSite(id) {
      // this.$store.dispatch("SET_SITE_ID", id);
      
      this.$emit("getSiteId", id);
      this.$emit("getActiveId", 3);
    },
    beforeSubmit() {
      this.preloader = true;
    },
    submit() {
      this.save(this.inputs);
    },

    afterSuccess(res) {
      this.$toastr.s(res.data.message);
    },
    afterFinalResponse() {
      this.preloader = false;
      this.inputs = {
        gender: "male",
      };
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
    clear() {
      this.inputs = {};
      this.fieldStatus = {
        isSubmit: false,
      };
    },
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    /**
     * for close add edit modal
     */
    closeAddEditModal() {
      this.isAddEditModalActive = false;
    },
    addNewSite() {
      this.addSite();
    },
    popSite(index) {
      this.site.splice(index, 1);
    },
    getSite() {
      axiosGet(COMPANY_JOB_SITE_SHOW + "/" + this.id)
        .then((res) => {
          this.site = res.data;
          this.site.start_time = this.site.starting_hours;
          this.site.end_time = this.site.ending_hours;
          this.tasks = this.site.tasks;
          // this.sites = this.job.sites;
        })
        .catch((error) => {
          
        });
    },
    updateSite() {
      this.preloader = true;
      axiosPost(COMPANY_JOB_SITE_UPDATE, this.site)
        .then((res) => {
          
          this.$toastr.s(res.data.type);
        })
        .catch((error) => {
          
          this.$toastr.e(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    // viewTask(id, { commit }) {
    //   
    //   commit("SET_SITE_ID", id);
    // },
  },

  mounted() {
    // let myLocation = location.href;
    // let split = myLocation.split("/");
    // let nsplit = split[7].split("?");
    this.getSite();
  },
};
</script>
